<template>
  <v-main>
    <div
      v-if="isLandingPage"
      class="peptide-landing-page"
    >
      <v-container
        class="py-12"
      >
        <h1 class="text-h2 white--text mb-8">
          Explore peptides
        </h1>

        <search-bar
          ref="searchBar"
          class="peptide-search-bar elevation-8"
          hide-type
          outlined
          type="Peptide"
        />
      </v-container>
    </div>
    <router-view />
  </v-main>
</template>

<script>
import SearchBar from '@/components/SearchBar'

export default {
  name: 'Peptide',
  components: {
    SearchBar
  },
  metaInfo () {
    return {
      title: 'Peptide',
      titleTemplate: '%s | ProteomicsDB',
      meta: [
        { charset: 'utf-8' },
        { name: 'description', content: 'The Peptide module allows for searching specific peptides along with any relevant information.' }
      ]
    }
  },
  computed: {
    /** @returns {boolean} */
    isLandingPage () {
      return this.$route.name === 'peptideHome'
    }
  },
  mounted () {
    if (this.isLandingPage) {
      this.$refs.searchBar.focus()
    }
  }
}
</script>

<style scoped lang="scss">
.peptide-landing-page {
  min-height: 40vh;
  background: rgb(2,0,36);
  background: linear-gradient(137deg, rgba(2,0,36,1) 0%, rgba(0,27,199,1) 20%, rgba(0,212,255,1) 84%);

  .peptide-search-bar {
    max-width: 960px;
  }
}
</style>
